import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Information = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="information-section">
        <div className="first-para">
          <h2>
            TIGA: Meme Culture. Casino Revenue. <span></span>
          </h2>
          <p>TIGA is an immersive project that blends meme culture with the $100B iGaming industry, one of the world’s most proven and profitable markets. Built by gaming veterans, TIGA.GAME turns casino volume into token value by redirecting profits into player cashback and staking rewards that add both velocity and scarcity to $TIGA.</p>
          <p>TIGA launches IDO with one of the lowest valuations ever seen on Gems for a real-revenue project, designed to maximize upside for early buyers.</p>
          <p>Players can deposit with fiat or crypto, swapping to $TIGA for higher cashback and exclusive benefits. Every wager fuels a deflationary token cycle where play itself drives demand. While traditional iGaming ads face strict limits, TIGA’s meme-driven virality unlocks global reach powered by community culture instead of paid marketing. Combined with AI-driven retention and a controlled DEX launch, TIGA bridges hype and utility to create a sustainable on-chain economy. The more players wager, the more $TIGA is bought, used, and removed from circulation.</p>
          <p>TIGA transforms meme energy into lasting value, merging entertainment and real yield across one of the world’s most established markets</p>
          <p>iGaming has grown every year since 2003, making it one of the most stable and scalable revenue engines in Web3.</p>
        </div>
        {/* <div className="first-para">
          <h2>iGaming Market Growth <span></span></h2>
          <p>The iGaming industry has never had a negative growth year and exceeds $100B in annual gross profit.</p>
        </div> */}
        <div className="first-para">
          <h2>
            What makes TIGA unique? <span></span>
          </h2>
          <ul>
            <li><span>$100B+ Proven Market:</span> Built on iGaming, one of the world’s most profitable and high-margin industries</li>
            <li><span>The House Gives Back:</span> Casino profits fuel player cashback and staking rewards for holders, creating both token velocity and scarcity</li>
            <li><span>Fiat and Crypto Onboarding:</span> Accepts all common deposit methods. Players are incentivized to swap to $TIGA for extra cashback, generating natural token demand</li>
            <li><span>Meme-Driven Global Growth:</span> Community-powered virality achieves massive reach in a market where traditional advertising is heavily restricted</li>
            <li><span>AI-Powered Retention and Marketing ROI:</span> Smart engagement systems turn every marketing dollar into recurring player activity and sustained token demand</li>
            <li><span>Audited and Controlled Launch:</span> Verified by AssureDeFi and SolidProof, with a managed DEX rollout that ensures stability and transparency</li>
          </ul>
        </div>
        <div className="first-para">
          <h2>
            Verified & Live <span></span>
          </h2>
          <p><span>Casino:</span> <a href="https://tiga.game" target="_blank">https://tiga.game</a></p>
          <p><span>Assure DeFi — Team KYC:</span> <a href="https://projects.assuredefi.com/project/tiga" target="_blank">https://projects.assuredefi.com/project/tiga</a></p>
          <p><span>SolidProof — Smart Contract Audit & KYC:</span> <a href="https://app.solidproof.io/projects/tiga" target="_blank">https://app.solidproof.io/projects/tiga</a></p>
          <p>TIGA is fully audited and KYC-verified, with identities held in escrow by Assure DeFi.</p>
        </div>
        <div className="first-para">
          <h2>
            Go-To-Market Strategy <span></span>
          </h2>
          <p>TIGA’s team brings a proven track record in iGaming marketing, delivering strong ROI through effective player acquisition and retention. This experience now powers a new tokenized model designed for speed and scale.</p>
          <p>By monetizing through $TIGA rather than casino profits, the platform can reward players more generously and grow faster than traditional operators. Users can deposit with fiat or crypto, swap to $TIGA, and drive token demand simply by playing. Growth compounds naturally. Cashback, referrals, and meme-driven virality accelerate user expansion, supported by traditional performance marketing enhanced with AI optimization.</p>
          <p>With deep marketing expertise, scalable incentives, and community-powered reach, TIGA converts gameplay into global token adoption, fast, efficient, and built to last.</p>
        </div>
        <div className="first-para">
          <h2>The TIGA Economic Engine <span></span></h2>
          <p><p>TIGA converts casino wagering into natural token demand.
            Player rewards, cashback, and staking incentives create ongoing buying pressure on $TIGA while reducing sell pressure through staking and in-ecosystem spending.</p></p>
          <h6>
            TOKENOMICS
          </h6>
          <div className="twice-tokenomics">
            {
              window.innerWidth < 600 ?
                <div className="tokenomic-img">
                  <img src="\assets\alldetailpages\tiga\info\graph.png" alt="img" className='img-fluid hide-in-light-theme' />
                  <img src="\assets\alldetailpages\tiga\info\graphlight.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
                </div>
                :
                <div className="tokenomic-img">
                  <img src="\assets\alldetailpages\tiga\info\graph.png" alt="img" className='img-fluid hide-in-light-theme' />
                  <img src="\assets\alldetailpages\tiga\info\graphlight.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
                </div>
            }
          </div>
        </div>
        <div className="first-para">
          <h2>
            RELEASE SCHEDULE <span></span>
          </h2>
          <div className="twice-tokenomics">
            {
              window.innerWidth < 600 ?
                <div className="tokenomic-img">
                  <img src="\assets\alldetailpages\tiga\info\schedule.png" alt="img" className='img-fluid hide-in-light-theme' />
                  <img src="\assets\alldetailpages\tiga\info\schedulelight.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
                </div>
                :
                <div className="tokenomic-img">
                  <img src="\assets\alldetailpages\tiga\info\schedule.png" alt="img" className='img-fluid hide-in-light-theme' />
                  <img src="\assets\alldetailpages\tiga\info\schedulelight.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
                </div>
            }
          </div>
        </div>
        <div className="first-para">
          <h2>
            {t('Inc-detailt34')} <span></span>
          </h2>
          <div className="team-gems" style={{ gridTemplateColumns: "1fr 1fr" }}>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\tiga\info\team\1.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">Sam (Founder & CEO) </h6>
              <p>Vision, strategy, and product. Over 8 years as an iGaming affiliate owner, Consulting executive background</p>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\tiga\info\team\2.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">Johnny (Casino Director) </h6>
              <p>Casino operations. 10+ years of iGaming management across major global operators.</p>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\tiga\info\team\3.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">Dara (Casino Marketing) </h6>
              <p>Growth, brand, and user acquisition. 8 years of experience in iGaming marketing.</p>

            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\tiga\info\team\4.png"
                alt="img"
                className="img-fluid"
                style={{ objectPosition: "50%" }}
              />
              <h6 className="mb-0">Amadeus (CTO) </h6>
              <p>WEB3 infrastructure and blockchain integration. Active in Web3 development since 2016.</p>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\tiga\info\team\5.png"
                alt="img"
                className="img-fluid"
                style={{ objectPosition: "50%" }}
              />
              <h6 className="mb-0">Summer (Token Marketing) </h6>
              <p>Strategy, Community building and partnerships. Crypto community builder and entrepreneur since 2016.</p>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\tiga\info\team\6.png"
                alt="img"
                className="img-fluid"
                style={{ objectPosition: "50%" }}
              />
              <h6 className="mb-0">Bald (Marketing Execution)</h6>
              <p>Campaign operations. Web3 marketer since 2017.</p>
            </div>
          </div>
        </div>
        <div className="first-para">
          <h2>Why the Team Uses Aliases <span></span></h2>
          <p>iGaming operators often work under aliases due to security risks linked to large financial flows and the nature of online gambling. However, the full team is <span style={{fontWeight: "700"}}>KYC-verified by Assure DeFi</span>, meaning identities are confirmed and can be disclosed in case of fraud or criminal activity.
            This structure protects both the team and the investors.</p>
        </div>
      </section>


    </>
  );
};

export default Information;